import { z } from 'zod/v4';
import { ToolCategory, ToolName, ToolNameSchema, ToolPolicy, ToolWeight, } from '../types.js';
import { searchEnvelopeSchema, searchInputSchema } from './envelope.js';
const filtersSchema = z.object({
    category: z
        .enum(ToolCategory)
        .optional()
        .describe('Restrict to a specific category. Call with no filters to see categories with their counts.'),
    weight: z
        .enum(ToolWeight)
        .optional()
        .describe('Restrict to LIGHT (read), HEAVY (mutation), or TERMINAL (run-ending) tools.'),
});
const itemSchema = z.object({
    name: ToolNameSchema,
    category: z.enum(ToolCategory),
    weight: z.enum(ToolWeight),
    brief: z
        .string()
        .describe('Short summary. Call get_tool to see the full schema before invoking.'),
});
const facetsSchema = z.object({
    byCategory: z.record(z.enum(ToolCategory), z.number().int()),
    byWeight: z.record(z.enum(ToolWeight), z.number().int()),
});
const inputSchema = searchInputSchema(filtersSchema);
const outputSchema = searchEnvelopeSchema(itemSchema, facetsSchema);
export const searchToolsTool = {
    name: ToolName.SearchTools,
    category: ToolCategory.Meta,
    weight: ToolWeight.Light,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: "Find tools available to you. Call with no arguments to see all tools grouped by category. Filter by category to browse one area, or use query to find tools matching a keyword. Use get_tool to see a tool's full schema and expose it for invocation.",
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=search-tools.js.map